module.exports = __webpack_public_path__ + "img/item_2.5112e1a9.png";